// // // import React from 'react';
// // // import { Box, Typography } from '@mui/material';
// // // import { keyframes } from '@emotion/react';
// // // import logo from '../assets/images/recyclebinLogo.png';

// // // // Animations
// // // const fadeIn = keyframes`
// // //   from { opacity: 0; }
// // //   to { opacity: 1; }
// // // `;

// // // const float = keyframes`
// // //   0% { transform: translateY(0px) scale(1); }
// // //   50% { transform: translateY(-20px) scale(1.05); }
// // //   100% { transform: translateY(0px) scale(1); }
// // // `;

// // // const pulse = keyframes`
// // //   0% { transform: scale(1); opacity: 1; }
// // //   50% { transform: scale(1.1); opacity: 0.8; }
// // //   100% { transform: scale(1); opacity: 1; }
// // // `;

// // // const gradient = keyframes`
// // //   0% { background-position: 0% 50%; }
// // //   50% { background-position: 100% 50%; }
// // //   100% { background-position: 0% 50%; }
// // // `;

// // // const shimmer = keyframes`
// // //   0% { transform: translateX(-100%); }
// // //   100% { transform: translateX(100%); }
// // // `;

// // // const particleFloat = keyframes`
// // //   0% { transform: translateY(0) rotate(0deg); opacity: 0; }
// // //   10% { opacity: 1; }
// // //   90% { opacity: 1; }
// // //   100% { transform: translateY(-100vh) rotate(360deg); opacity: 0; }
// // // `;

// // // const textGlow = keyframes`
// // //   0%, 100% { text-shadow: 0 0 10px rgba(74, 144, 226, 0.5), 0 0 20px rgba(74, 144, 226, 0.3); }
// // //   50% { text-shadow: 0 0 20px rgba(74, 144, 226, 0.8), 0 0 30px rgba(74, 144, 226, 0.5), 0 0 40px rgba(74, 144, 226, 0.3); }
// // // `;

// // // interface SplashScreenProps {
// // //   duration?: number;
// // //   onComplete?: () => void;
// // // }

// // // const SplashScreen: React.FC<SplashScreenProps> = ({ duration = 3000, onComplete }) => {
// // //   React.useEffect(() => {
// // //     const timer = setTimeout(() => {
// // //       onComplete?.();
// // //     }, duration);

// // //     return () => clearTimeout(timer);
// // //   }, [duration, onComplete]);

// // //   // Generate random particles
// // //   const particles = Array.from({ length: 15 }, (_, i) => ({
// // //     id: i,
// // //     left: Math.random() * 100,
// // //     delay: Math.random() * 2,
// // //     duration: 3 + Math.random() * 2,
// // //     size: 5 + Math.random() * 10,
// // //   }));

// // //   const styles = {
// // //     container: {
// // //       position: 'fixed',
// // //       top: 0,
// // //       left: 0,
// // //       width: '100%',
// // //       height: '100%',
// // //       display: 'flex',
// // //       flexDirection: 'column' as const,
// // //       justifyContent: 'center',
// // //       alignItems: 'center',
// // //       background: 'linear-gradient(-45deg, #667eea, #764ba2, #f093fb, #f5576c)',
// // //       backgroundSize: '400% 400%',
// // //       animation: `${gradient} 8s ease infinite`,
// // //       overflow: 'hidden',
// // //       zIndex: 9999,
// // //     },
// // //     overlay: {
// // //       position: 'absolute',
// // //       top: 0,
// // //       left: 0,
// // //       width: '100%',
// // //       height: '100%',
// // //       background: 'rgba(255, 255, 255, 0.1)',
// // //       backdropFilter: 'blur(5px)',
// // //     },
// // //     content: {
// // //       position: 'relative',
// // //       zIndex: 2,
// // //       textAlign: 'center' as const,
// // //       animation: `${fadeIn} 1s ease-out`,
// // //     },
// // //     logoContainer: {
// // //       position: 'relative',
// // //       marginBottom: '2rem',
// // //     },
// // //     logo: {
// // //       width: '120px',
// // //       height: '120px',
// // //       animation: `${float} 3s ease-in-out infinite, ${pulse} 2s ease-in-out infinite`,
// // //       filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.3))',
// // //     },
// // //     logoGlow: {
// // //       position: 'absolute' as const,
// // //       top: '50%',
// // //       left: '50%',
// // //       transform: 'translate(-50%, -50%)',
// // //       width: '140px',
// // //       height: '140px',
// // //       background: 'radial-gradient(circle, rgba(74,144,226,0.4) 0%, transparent 70%)',
// // //       borderRadius: '50%',
// // //       animation: `${pulse} 2s ease-in-out infinite`,
// // //     },
// // //     title: {
// // //       fontSize: '2.5rem',
// // //       fontWeight: 'bold',
// // //       background: 'linear-gradient(45deg, #ffffff, #e3f2fd, #bbdefb)',
// // //       backgroundClip: 'text',
// // //       WebkitBackgroundClip: 'text',
// // //       color: 'transparent',
// // //       animation: `${textGlow} 2s ease-in-out infinite`,
// // //       marginBottom: '1rem',
// // //       letterSpacing: '2px',
// // //     },
// // //     subtitle: {
// // //       fontSize: '1.2rem',
// // //       color: 'rgba(255, 255, 255, 0.9)',
// // //       fontStyle: 'italic',
// // //       marginBottom: '2rem',
// // //       animation: `${fadeIn} 1s ease-out 0.5s both`,
// // //     },
// // //     loadingBar: {
// // //       width: '200px',
// // //       height: '4px',
// // //       background: 'rgba(255, 255, 255, 0.3)',
// // //       borderRadius: '2px',
// // //       overflow: 'hidden',
// // //       position: 'relative' as const,
// // //     },
// // //     loadingProgress: {
// // //       position: 'absolute' as const,
// // //       top: 0,
// // //       left: 0,
// // //       height: '100%',
// // //       background: 'linear-gradient(90deg, transparent, #ffffff, transparent)',
// // //       animation: `${shimmer} 2s ease-in-out infinite`,
// // //       width: '50%',
// // //     },
// // //     particle: (particle: any) => ({
// // //       position: 'absolute' as const,
// // //       top: '100%',
// // //       left: `${particle.left}%`,
// // //       width: `${particle.size}px`,
// // //       height: `${particle.size}px`,
// // //       background: 'rgba(255, 255, 255, 0.6)',
// // //       borderRadius: '50%',
// // //       animation: `${particleFloat} ${particle.duration}s linear infinite ${particle.delay}s`,
// // //     }),
// // //     footer: {
// // //       position: 'absolute' as const,
// // //       bottom: '2rem',
// // //       color: 'rgba(255, 255, 255, 0.7)',
// // //       fontSize: '0.9rem',
// // //       animation: `${fadeIn} 1s ease-out 1s both`,
// // //     },
// // //   };

// // //   return (
// // //     <Box sx={styles.container}>
// // //       {/* Animated Background Overlay */}
// // //       <Box sx={styles.overlay} />
      
// // //       {/* Floating Particles */}
// // //       {particles.map(particle => (
// // //         <Box key={particle.id} sx={styles.particle(particle)} />
// // //       ))}
      
// // //       {/* Main Content */}
// // //       <Box sx={styles.content}>
// // //         <Box sx={styles.logoContainer}>
// // //           <Box sx={styles.logoGlow} />
// // //           <img
// // //             src={logo}
// // //             alt="DDMSS Logo"
// // //             style={styles.logo}
// // //           />
// // //         </Box>
        
// // //         <Typography variant="h1" sx={styles.title}>
// // //           DDMSS
// // //         </Typography>
        
// // //         <Typography variant="h6" sx={styles.subtitle}>
// // //           Digital Document Management System
// // //         </Typography>
        
// // //         <Box sx={styles.loadingBar}>
// // //           <Box sx={styles.loadingProgress} />
// // //         </Box>
// // //       </Box>
      
// // //       <Typography variant="body2" sx={styles.footer}>
// // //         Loading your workspace...
// // //       </Typography>
// // //     </Box>
// // //   );
// // // };

// // // export default SplashScreen;

import React from 'react';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@emotion/react';
import logo from '../assets/images/recyclebinLogo.png';

// Premium Animations
const fadeIn = keyframes`
  from { 
    opacity: 0; 
    transform: translateY(30px) scale(0.95); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0) scale(1); 
  }
`;

const float = keyframes`
  0% { transform: translateY(0px) rotate(0deg) scale(1); }
  33% { transform: translateY(-15px) rotate(2deg) scale(1.02); }
  66% { transform: translateY(5px) rotate(-1deg) scale(0.98); }
  100% { transform: translateY(0px) rotate(0deg) scale(1); }
`;

const pulse = keyframes`
  0% { 
    transform: scale(1); 
    opacity: 1; 
    filter: brightness(1) drop-shadow(0 0 20px rgba(74, 144, 226, 0.3));
  }
  50% { 
    transform: scale(1.08); 
    opacity: 0.9; 
    filter: brightness(1.2) drop-shadow(0 0 30px rgba(74, 144, 226, 0.6));
  }
  100% { 
    transform: scale(1); 
    opacity: 1; 
    filter: brightness(1) drop-shadow(0 0 20px rgba(74, 144, 226, 0.3));
  }
`;

const gradientFlow = keyframes`
  0% { 
    background-position: 0% 50%; 
    filter: hue-rotate(0deg);
  }
  50% { 
    background-position: 100% 50%; 
    filter: hue-rotate(45deg);
  }
  100% { 
    background-position: 0% 50%; 
    filter: hue-rotate(0deg);
  }
`;

const documentFloat = keyframes`
  0% { 
    transform: translateY(100vh) rotate(0deg) scale(0.8);
    opacity: 0;
  }
  10% { 
    opacity: 0.8;
  }
  90% { 
    opacity: 0.8;
  }
  100% { 
    transform: translateY(-100px) rotate(360deg) scale(1.2);
    opacity: 0;
  }
`;

const shimmerWave = keyframes`
  0% { 
    transform: translateX(-100%) skewX(-15deg);
    opacity: 0;
  }
  50% { 
    opacity: 1;
  }
  100% { 
    transform: translateX(200%) skewX(-15deg);
    opacity: 0;
  }
`;

const textShine = keyframes`
  0% { 
    background-position: -200% center;
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.5));
  }
  100% { 
    background-position: 200% center;
    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.8));
  }
`;

const welcomeGlow = keyframes`
  0%, 100% { 
    text-shadow: 
      0 0 20px rgba(255, 255, 255, 0.6),
      0 0 40px rgba(255, 255, 255, 0.4),
      0 0 60px rgba(255, 255, 255, 0.2);
    transform: scale(1);
  }
  50% { 
    text-shadow: 
      0 0 30px rgba(255, 255, 255, 0.8),
      0 0 60px rgba(255, 255, 255, 0.6),
      0 0 90px rgba(255, 255, 255, 0.4);
    transform: scale(1.02);
  }
`;

const typewriter = keyframes`
  from { 
    width: 0;
    opacity: 0;
  }
  to { 
    width: 100%;
    opacity: 1;
  }
`;

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

interface SplashScreenProps {
  duration?: number;
  onComplete?: () => void;
  userName?: string; // Optional prop for personalized welcome
}

const PremiumSplashScreen: React.FC<SplashScreenProps> = ({ 
  duration = 3500, 
  onComplete,
  userName 
}) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      onComplete?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onComplete]);

  // Document-themed particles with different shapes and colors
  const documents = Array.from({ length: 12 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 3,
    duration: 4 + Math.random() * 3,
    size: 20 + Math.random() * 40,
    type: Math.floor(Math.random() * 3), // 0: document, 1: folder, 2: page
    rotation: Math.random() * 360,
    color: `rgba(${Math.random() * 100 + 155}, ${Math.random() * 100 + 155}, 255, ${0.3 + Math.random() * 0.4})`
  }));

  const styles = {
    container: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column' as const,
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 25%, #2c3e50 50%, #34495e 75%, #667eea 100%)',
      backgroundSize: '400% 400%',
      animation: `${gradientFlow} 12s ease infinite`,
      overflow: 'hidden',
      zIndex: 9999,
      fontFamily: '"Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    
    glassOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
      backdropFilter: 'blur(10px) saturate(180%)',
      WebkitBackdropFilter: 'blur(10px) saturate(180%)',
    },
    
    content: {
      position: 'relative',
      zIndex: 3,
      textAlign: 'center' as const,
      animation: `${fadeIn} 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)`,
      padding: { xs: '1rem', sm: '2rem', md: '3rem' },
      maxWidth: { xs: '90%', sm: '80%', md: '600px' },
      width: '100%',
    },
    
    // Welcome Message Section
    welcomeSection: {
      marginBottom: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
      animation: `${fadeInUp} 1s ease-out 0.3s both`,
    },
    
    welcomeText: {
      fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3rem' },
      fontWeight: '700',
      color: 'rgba(255, 255, 255, 0.95)',
      animation: `${welcomeGlow} 2s ease-in-out infinite`,
      marginBottom: '0.5rem',
      textShadow: '0 2px 10px rgba(0,0,0,0.3)',
      fontFamily: '"Playfair Display", "Georgia", serif',
      letterSpacing: '0.5px',
    },
    
    personalizedWelcome: {
      fontSize: { xs: '1.2rem', sm: '1.6rem', md: '1.8rem' },
      fontWeight: '400',
      color: 'rgba(255, 255, 255, 0.85)',
      fontStyle: 'italic',
      marginBottom: '1rem',
      animation: `${fadeInUp} 1s ease-out 0.6s both`,
      textShadow: '0 1px 5px rgba(0,0,0,0.2)',
    },
    
    tagline: {
      fontSize: { xs: '0.9rem', sm: '1.1rem', md: '1.2rem' },
      color: 'rgba(255, 255, 255, 0.7)',
      fontWeight: '300',
      animation: `${fadeInUp} 1s ease-out 0.9s both`,
      letterSpacing: '0.3px',
      maxWidth: '400px',
      margin: '0 auto',
      lineHeight: 1.4,
    },
    
    logoSection: {
      position: 'relative',
      marginBottom: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
      display: 'flex',
      flexDirection: 'column' as const,
      alignItems: 'center',
      animation: `${fadeInUp} 1s ease-out 1.2s both`,
    },
    
    logoOrb: {
      position: 'relative',
      width: { xs: '80px', sm: '100px', md: '120px' },
      height: { xs: '80px', sm: '100px', md: '120px' },
      marginBottom: '1rem',
    },
    
    logoGlow: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: { xs: '100px', sm: '120px', md: '140px' },
      height: { xs: '100px', sm: '120px', md: '140px' },
      background: 'radial-gradient(circle, rgba(74,144,226,0.6) 0%, rgba(74,144,226,0.2) 50%, transparent 70%)',
      borderRadius: '50%',
      animation: `${pulse} 3s ease-in-out infinite`,
      filter: 'blur(10px)',
    },
    
    logo: {
      width: '100%',
      height: '100%',
      animation: `${float} 4s ease-in-out infinite, ${pulse} 3s ease-in-out infinite`,
      filter: 'drop-shadow(0 15px 30px rgba(0,0,0,0.4))',
      borderRadius: '20%',
      background: 'linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.7))',
      padding: '12px',
      boxSizing: 'border-box' as const,
    },
    
    title: {
      fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3rem' },
      fontWeight: '800',
      background: 'linear-gradient(45deg, #ffffff 0%, #e3f2fd 30%, #bbdefb 70%, #ffffff 100%)',
      backgroundSize: '200% auto',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      animation: `${textShine} 3s ease-in-out infinite`,
      marginBottom: { xs: '0.3rem', sm: '0.5rem', md: '0.6rem' },
      letterSpacing: { xs: '1px', sm: '1.5px', md: '2px' },
      textTransform: 'uppercase' as const,
      fontFamily: '"Segoe UI", "Roboto", sans-serif',
      lineHeight: 1.1,
    },
    
    subtitle: {
      fontSize: { xs: '0.8rem', sm: '1rem', md: '1.1rem' },
      color: 'rgba(255, 255, 255, 0.9)',
      fontStyle: 'italic',
      marginBottom: { xs: '1rem', sm: '1.5rem', md: '2rem' },
      fontWeight: '300',
      letterSpacing: '0.3px',
      textShadow: '0 1px 5px rgba(0,0,0,0.2)',
    },
    
    progressContainer: {
      width: { xs: '250px', sm: '300px', md: '350px' },
      height: '6px',
      background: 'rgba(255, 255, 255, 0.15)',
      borderRadius: '3px',
      overflow: 'hidden',
      position: 'relative' as const,
      margin: '0 auto',
      backdropFilter: 'blur(5px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      animation: `${fadeInUp} 1s ease-out 1.5s both`,
    },
    
    progressWave: {
      position: 'absolute' as const,
      top: 0,
      left: 0,
      height: '100%',
      width: '30%',
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.8), transparent)',
      animation: `${shimmerWave} 2s ease-in-out infinite`,
      borderRadius: '3px',
    },
    
    document: (doc: any) => ({
      position: 'absolute' as const,
      top: '110%',
      left: `${doc.left}%`,
      width: `${doc.size}px`,
      height: `${doc.type === 1 ? doc.size * 0.7 : doc.size * 1.4}px`,
      background: doc.color,
      borderRadius: doc.type === 1 ? '4px 4px 8px 8px' : '2px',
      transform: `rotate(${doc.rotation}deg)`,
      animation: `${documentFloat} ${doc.duration}s linear infinite ${doc.delay}s`,
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
      '&::before': doc.type === 2 ? {
        content: '""',
        position: 'absolute',
        top: '10%',
        left: '10%',
        right: '10%',
        height: '2px',
        background: 'rgba(255,255,255,0.5)',
        borderRadius: '1px',
      } : {},
      '&::after': doc.type === 0 ? {
        content: '""',
        position: 'absolute',
        bottom: '15%',
        left: '10%',
        right: '10%',
        height: '2px',
        background: 'rgba(255,255,255,0.5)',
        borderRadius: '1px',
      } : {},
    }),
    
    footer: {
      position: 'absolute' as const,
      bottom: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: { xs: '0.75rem', sm: '0.85rem', md: '0.9rem' },
      animation: `${fadeIn} 1s ease-out 1.8s both`,
      textAlign: 'center' as const,
      width: '100%',
      fontWeight: '300',
      letterSpacing: '0.3px',
    },
    
    featureGrid: {
      display: { xs: 'none', sm: 'grid' },
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: { sm: '1rem', md: '2rem' },
      marginTop: { sm: '1.5rem', md: '2rem' },
      animation: `${fadeInUp} 1s ease-out 1.8s both`,
    },
    
    featureItem: {
      textAlign: 'center' as const,
      padding: { sm: '0.5rem', md: '0.8rem' },
      background: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '10px',
      backdropFilter: 'blur(5px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    
    featureIcon: {
      fontSize: { sm: '1.3rem', md: '1.6rem' },
      color: 'rgba(255, 255, 255, 0.9)',
      marginBottom: '0.3rem',
      filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.3))',
    },
    
    featureText: {
      fontSize: { sm: '0.65rem', md: '0.75rem' },
      color: 'rgba(255, 255, 255, 0.8)',
      fontWeight: '400',
    },
  };

  return (
    <Box sx={styles.container}>
      {/* Glass Morphism Overlay */}
      <Box sx={styles.glassOverlay} />
      
      {/* Animated Document Elements */}
      {documents.map(doc => (
        <Box key={doc.id} sx={styles.document(doc)} />
      ))}
      
      {/* Main Content */}
      <Box sx={styles.content}>
        {/* Welcome Message Section */}
        <Box sx={styles.welcomeSection}>
          <Typography variant="h1" sx={styles.welcomeText}>
            Welcome
          </Typography>
          {userName && (
            <Typography variant="h2" sx={styles.personalizedWelcome}>
              {userName}!
            </Typography>
          )}
          <Typography variant="body1" sx={styles.tagline}>
            We're preparing your digital workspace with care and precision
          </Typography>
        </Box>

        {/* Logo and System Info Section */}
        <Box sx={styles.logoSection}>
          <Box sx={styles.logoOrb}>
            <Box sx={styles.logoGlow} />
            <img
              src={logo}
              alt="DDMSS Logo"
              style={styles.logo}
            />
          </Box>
          
          <Typography variant="h1" sx={styles.title}>
            DDMSS
          </Typography>
          
          <Typography variant="h6" sx={styles.subtitle}>
            Digital Document Management System
          </Typography>
        </Box>
        
        {/* Progress Indicator */}
        <Box sx={styles.progressContainer}>
          <Box sx={styles.progressWave} />
        </Box>
        
        {/* Feature Highlights - Hidden on mobile */}
        <Box sx={styles.featureGrid}>
          <Box sx={styles.featureItem}>
            <Box sx={styles.featureIcon}>📁</Box>
            <Typography variant="body2" sx={styles.featureText}>
              Secure Storage
            </Typography>
          </Box>
          <Box sx={styles.featureItem}>
            <Box sx={styles.featureIcon}>⚡</Box>
            <Typography variant="body2" sx={styles.featureText}>
              Fast Access
            </Typography>
          </Box>
          <Box sx={styles.featureItem}>
            <Box sx={styles.featureIcon}>🔒</Box>
            <Typography variant="body2" sx={styles.featureText}>
              Enterprise Grade
            </Typography>
          </Box>
        </Box>
      </Box>
      
      
    </Box>
  );
};

export default PremiumSplashScreen;



// import React from 'react';
// import { Box, Typography } from '@mui/material';
// import { keyframes } from '@emotion/react';
// import logo from '../assets/images/recyclebinLogo.png';

// // Premium Animations
// const fadeIn = keyframes`
//   from { 
//     opacity: 0; 
//     transform: translateY(30px) scale(0.95); 
//   }
//   to { 
//     opacity: 1; 
//     transform: translateY(0) scale(1); 
//   }
// `;

// const float = keyframes`
//   0% { transform: translateY(0px) rotate(0deg) scale(1); }
//   33% { transform: translateY(-12px) rotate(1deg) scale(1.02); }
//   66% { transform: translateY(3px) rotate(-0.5deg) scale(0.98); }
//   100% { transform: translateY(0px) rotate(0deg) scale(1); }
// `;

// const pulse = keyframes`
//   0% { 
//     transform: scale(1); 
//     opacity: 1; 
//     filter: brightness(1) drop-shadow(0 0 15px rgba(74, 144, 226, 0.4));
//   }
//   50% { 
//     transform: scale(1.05); 
//     opacity: 0.9; 
//     filter: brightness(1.15) drop-shadow(0 0 25px rgba(74, 144, 226, 0.7));
//   }
//   100% { 
//     transform: scale(1); 
//     opacity: 1; 
//     filter: brightness(1) drop-shadow(0 0 15px rgba(74, 144, 226, 0.4));
//   }
// `;

// const gradientFlow = keyframes`
//   0% { 
//     background-position: 0% 50%;
//   }
//   50% { 
//     background-position: 100% 50%;
//   }
//   100% { 
//     background-position: 0% 50%;
//   }
// `;

// const documentFloat = keyframes`
//   0% { 
//     transform: translateY(100vh) rotate(0deg) scale(0.7);
//     opacity: 0;
//   }
//   8% { 
//     opacity: 0.7;
//   }
//   92% { 
//     opacity: 0.7;
//   }
//   100% { 
//     transform: translateY(-150px) rotate(360deg) scale(1.1);
//     opacity: 0;
//   }
// `;

// const shimmerWave = keyframes`
//   0% { 
//     transform: translateX(-100%) skewX(-15deg);
//     opacity: 0;
//   }
//   50% { 
//     opacity: 1;
//   }
//   100% { 
//     transform: translateX(200%) skewX(-15deg);
//     opacity: 0;
//   }
// `;

// const textShine = keyframes`
//   0% { 
//     background-position: -200% center;
//     filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.4));
//   }
//   100% { 
//     background-position: 200% center;
//     filter: drop-shadow(0 0 15px rgba(255, 255, 255, 0.6));
//   }
// `;

// const glow = keyframes`
//   0%, 100% { 
//     box-shadow: 0 0 20px rgba(59, 130, 246, 0.4),
//                 0 0 40px rgba(59, 130, 246, 0.2),
//                 0 0 60px rgba(59, 130, 246, 0.1);
//   }
//   50% { 
//     box-shadow: 0 0 30px rgba(59, 130, 246, 0.6),
//                 0 0 60px rgba(59, 130, 246, 0.3),
//                 0 0 90px rgba(59, 130, 246, 0.2);
//   }
// `;

// interface SplashScreenProps {
//   duration?: number;
//   onComplete?: () => void;
// }

// const PremiumSplashScreen: React.FC<SplashScreenProps> = ({ duration = 3000, onComplete }) => {
//   React.useEffect(() => {
//     const timer = setTimeout(() => {
//       onComplete?.();
//     }, duration);

//     return () => clearTimeout(timer);
//   }, [duration, onComplete]);

//   // Document-themed particles
//   const documents = Array.from({ length: 10 }, (_, i) => ({
//     id: i,
//     left: Math.random() * 100,
//     delay: Math.random() * 2,
//     duration: 3 + Math.random() * 2,
//     size: 15 + Math.random() * 25,
//     type: Math.floor(Math.random() * 3),
//     rotation: Math.random() * 360,
//     color: `rgba(${Math.random() * 55 + 200}, ${Math.random() * 55 + 200}, 255, ${0.2 + Math.random() * 0.3})`
//   }));

//   const styles = {
//     container: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       width: '100%',
//       height: '100%',
//       display: 'flex',
//       flexDirection: 'column' as const,
//       justifyContent: 'center',
//       alignItems: 'center',
//       // Premium gradient background - Deep Blue to Purple
//       background: 'linear-gradient(135deg, #1e3a8a 0%, #3730a3 25%, #5b21b6 50%, #7e22ce 75%, #a855f7 100%)',
//       backgroundSize: '400% 400%',
//       animation: `${gradientFlow} 15s ease infinite`,
//       overflow: 'hidden',
//       zIndex: 9999,
//       fontFamily: '"Segoe UI", "Inter", "SF Pro Display", -apple-system, sans-serif',
//     },
    
//     glassOverlay: {
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       width: '100%',
//       height: '100%',
//       background: 'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.02) 100%)',
//       backdropFilter: 'blur(12px) saturate(200%)',
//       WebkitBackdropFilter: 'blur(12px) saturate(200%)',
//     },
    
//     content: {
//       position: 'relative',
//       zIndex: 3,
//       textAlign: 'center' as const,
//       animation: `${fadeIn} 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)`,
//       padding: { xs: '1rem', sm: '1.5rem', md: '2rem' },
//       maxWidth: { xs: '90%', sm: '400px', md: '450px' },
//       width: '100%',
//     },
    
//     logoSection: {
//       position: 'relative',
//       marginBottom: { xs: '1rem', sm: '1.5rem', md: '2rem' },
//       display: 'flex',
//       flexDirection: 'column' as const,
//       alignItems: 'center',
//     },
    
//     logoContainer: {
//       position: 'relative',
//       width: { xs: '70px', sm: '80px', md: '90px' }, // Compact size
//       height: { xs: '70px', sm: '80px', md: '90px' }, // Compact size
//       marginBottom: { xs: '0.8rem', sm: '1rem', md: '1.2rem' },
//       animation: `${glow} 3s ease-in-out infinite`,
//       borderRadius: '20%',
//       padding: '8px',
//       background: 'linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,255,255,0.85))',
//       boxSizing: 'border-box' as const,
//     },
    
//     logoGlow: {
//       position: 'absolute',
//       top: '50%',
//       left: '50%',
//       transform: 'translate(-50%, -50%)',
//       width: { xs: '85px', sm: '95px', md: '105px' },
//       height: { xs: '85px', sm: '95px', md: '105px' },
//       background: 'radial-gradient(circle, rgba(59, 130, 246, 0.5) 0%, rgba(59, 130, 246, 0.2) 40%, transparent 70%)',
//       borderRadius: '50%',
//       animation: `${pulse} 2.5s ease-in-out infinite`,
//       filter: 'blur(8px)',
//     },
    
//     logo: {
//       width: '100%',
//       height: '100%',
//       animation: `${float} 3.5s ease-in-out infinite`,
//       filter: 'drop-shadow(0 8px 20px rgba(0,0,0,0.3))',
//       borderRadius: '18%',
//       objectFit: 'contain' as const,
//     },
    
//     title: {
//       fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.5rem' },
//       fontWeight: '800',
//       background: 'linear-gradient(45deg, #ffffff 0%, #e0f2fe 25%, #bae6fd 50%, #e0f2fe 75%, #ffffff 100%)',
//       backgroundSize: '200% auto',
//       backgroundClip: 'text',
//       WebkitBackgroundClip: 'text',
//       WebkitTextFillColor: 'transparent',
//       animation: `${textShine} 2.5s ease-in-out infinite`,
//       marginBottom: { xs: '0.3rem', sm: '0.5rem', md: '0.6rem' },
//       letterSpacing: { xs: '0.5px', sm: '1px', md: '1.5px' },
//       textTransform: 'uppercase' as const,
//       fontFamily: '"Inter", "SF Pro Display", sans-serif',
//       lineHeight: 1.1,
//     },
    
//     subtitle: {
//       fontSize: { xs: '0.75rem', sm: '0.9rem', md: '1rem' },
//       color: 'rgba(255, 255, 255, 0.9)',
//       fontStyle: 'italic',
//       marginBottom: { xs: '1.2rem', sm: '1.5rem', md: '2rem' },
//       animation: `${fadeIn} 1.2s ease-out 0.3s both`,
//       fontWeight: '300',
//       letterSpacing: '0.3px',
//       textShadow: '0 1px 8px rgba(0,0,0,0.2)',
//     },
    
//     progressContainer: {
//       width: { xs: '200px', sm: '250px', md: '280px' },
//       height: '4px',
//       background: 'rgba(255, 255, 255, 0.12)',
//       borderRadius: '2px',
//       overflow: 'hidden',
//       position: 'relative' as const,
//       margin: '0 auto',
//       backdropFilter: 'blur(4px)',
//       border: '1px solid rgba(255, 255, 255, 0.08)',
//     },
    
//     progressWave: {
//       position: 'absolute' as const,
//       top: 0,
//       left: 0,
//       height: '100%',
//       width: '35%',
//       background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.9), transparent)',
//       animation: `${shimmerWave} 1.8s ease-in-out infinite`,
//       borderRadius: '2px',
//     },
    
//     document: (doc: any) => ({
//       position: 'absolute' as const,
//       top: '110%',
//       left: `${doc.left}%`,
//       width: `${doc.size}px`,
//       height: `${doc.type === 1 ? doc.size * 0.7 : doc.size * 1.3}px`,
//       background: doc.color,
//       borderRadius: doc.type === 1 ? '3px 3px 6px 6px' : '1px',
//       transform: `rotate(${doc.rotation}deg)`,
//       animation: `${documentFloat} ${doc.duration}s linear infinite ${doc.delay}s`,
//       boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
//       '&::before': doc.type === 2 ? {
//         content: '""',
//         position: 'absolute',
//         top: '15%',
//         left: '15%',
//         right: '15%',
//         height: '1px',
//         background: 'rgba(255,255,255,0.6)',
//         borderRadius: '0.5px',
//       } : {},
//       '&::after': doc.type === 0 ? {
//         content: '""',
//         position: 'absolute',
//         bottom: '20%',
//         left: '15%',
//         right: '15%',
//         height: '1px',
//         background: 'rgba(255,255,255,0.4)',
//         borderRadius: '0.5px',
//       } : {},
//     }),
    
//     footer: {
//       position: 'absolute' as const,
//       bottom: { xs: '1rem', sm: '1.5rem', md: '2rem' },
//       color: 'rgba(255, 255, 255, 0.75)',
//       fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
//       animation: `${fadeIn} 0.8s ease-out 0.5s both`,
//       textAlign: 'center' as const,
//       width: '100%',
//       fontWeight: '300',
//       letterSpacing: '0.3px',
//     },
    
//     featureGrid: {
//       display: { xs: 'none', sm: 'flex' },
//       justifyContent: 'center',
//       gap: { sm: '1.5rem', md: '2rem' },
//       marginTop: { sm: '1.5rem', md: '2rem' },
//       animation: `${fadeIn} 0.8s ease-out 0.6s both`,
//     },
    
//     featureItem: {
//       textAlign: 'center' as const,
//       padding: { sm: '0.3rem', md: '0.5rem' },
//     },
    
//     featureIcon: {
//       fontSize: { sm: '1.2rem', md: '1.4rem' },
//       color: 'rgba(255, 255, 255, 0.9)',
//       marginBottom: '0.3rem',
//       filter: 'drop-shadow(0 1px 6px rgba(0,0,0,0.2))',
//     },
    
//     featureText: {
//       fontSize: { sm: '0.65rem', md: '0.7rem' },
//       color: 'rgba(255, 255, 255, 0.75)',
//       fontWeight: '300',
//       letterSpacing: '0.2px',
//     },
//   };

//   return (
//     <Box sx={styles.container}>
//       {/* Glass Morphism Overlay */}
//       <Box sx={styles.glassOverlay} />
      
//       {/* Animated Document Elements */}
//       {documents.map(doc => (
//         <Box key={doc.id} sx={styles.document(doc)} />
//       ))}
      
//       {/* Main Content */}
//       <Box sx={styles.content}>
//         <Box sx={styles.logoSection}>
//           <Box sx={styles.logoContainer}>
//             <Box sx={styles.logoGlow} />
//             <img
//               src={logo}
//               alt="DDMSS Logo"
//               style={styles.logo}
//             />
//           </Box>
          
//           <Typography variant="h1" sx={styles.title}>
//             DDMSS
//           </Typography>
          
//           <Typography variant="h6" sx={styles.subtitle}>
//             Digital Document Management System
//           </Typography>
//         </Box>
        
//         {/* Progress Indicator */}
//         <Box sx={styles.progressContainer}>
//           <Box sx={styles.progressWave} />
//         </Box>
        
//         {/* Feature Highlights - Hidden on mobile */}
//         <Box sx={styles.featureGrid}>
//           <Box sx={styles.featureItem}>
//             <Box sx={styles.featureIcon}>📁</Box>
//             <Typography variant="body2" sx={styles.featureText}>
//               Secure
//             </Typography>
//           </Box>
//           <Box sx={styles.featureItem}>
//             <Box sx={styles.featureIcon}>⚡</Box>
//             <Typography variant="body2" sx={styles.featureText}>
//               Fast
//             </Typography>
//           </Box>
//           <Box sx={styles.featureItem}>
//             <Box sx={styles.featureIcon}>🔒</Box>
//             <Typography variant="body2" sx={styles.featureText}>
//               Reliable
//             </Typography>
//           </Box>
//         </Box>
//       </Box>
      
//       <Typography variant="body2" sx={styles.footer}>
//         Preparing your workspace...
//       </Typography>
//     </Box>
//   );
// };

// export default PremiumSplashScreen;

















// import React from 'react';
// import { Box, Typography } from '@mui/material';
// import { keyframes } from '@emotion/react';
// import logo from '../assets/images/recyclebinLogo.png';

// // Premium 3D Animations
// const fadeIn3D = keyframes`
//   from { 
//     opacity: 0; 
//     transform: translateY(50px) rotateX(45deg) scale(0.8);
//   }
//   to { 
//     opacity: 1; 
//     transform: translateY(0) rotateX(0) scale(1);
//   }
// `;

// const float3D = keyframes`
//   0% { 
//     transform: translateY(0px) rotateY(0deg) scale3d(1, 1, 1);
//     filter: drop-shadow(0 5px 15px rgba(255, 69, 0, 0.3));
//   }
//   33% { 
//     transform: translateY(-15px) rotateY(5deg) scale3d(1.02, 1.02, 1.02);
//     filter: drop-shadow(0 10px 25px rgba(255, 69, 0, 0.5));
//   }
//   66% { 
//     transform: translateY(5px) rotateY(-3deg) scale3d(0.98, 0.98, 0.98);
//     filter: drop-shadow(0 8px 20px rgba(255, 69, 0, 0.4));
//   }
//   100% { 
//     transform: translateY(0px) rotateY(0deg) scale3d(1, 1, 1);
//     filter: drop-shadow(0 5px 15px rgba(255, 69, 0, 0.3));
//   }
// `;

// const pulse3D = keyframes`
//   0% { 
//     transform: scale3d(1, 1, 1);
//     filter: brightness(1) drop-shadow(0 0 20px rgba(255, 69, 0, 0.4));
//   }
//   50% { 
//     transform: scale3d(1.06, 1.06, 1.06);
//     filter: brightness(1.2) drop-shadow(0 0 35px rgba(255, 140, 0, 0.7));
//   }
//   100% { 
//     transform: scale3d(1, 1, 1);
//     filter: brightness(1) drop-shadow(0 0 20px rgba(255, 69, 0, 0.4));
//   }
// `;

// const bhagwaGradientFlow = keyframes`
//   0% { 
//     background-position: 0% 50%;
//     filter: hue-rotate(0deg) saturate(120%);
//   }
//   25% {
//     background-position: 50% 100%;
//     filter: hue-rotate(5deg) saturate(130%);
//   }
//   50% { 
//     background-position: 100% 50%;
//     filter: hue-rotate(10deg) saturate(140%);
//   }
//   75% {
//     background-position: 50% 0%;
//     filter: hue-rotate(5deg) saturate(130%);
//   }
//   100% { 
//     background-position: 0% 50%;
//     filter: hue-rotate(0deg) saturate(120%);
//   }
// `;

// const documentFloat3D = keyframes`
//   0% { 
//     transform: 
//       translateY(120vh) 
//       rotateX(60deg) 
//       rotateZ(0deg) 
//       scale3d(0.6, 0.6, 0.6);
//     opacity: 0;
//   }
//   10% { 
//     opacity: 0.8;
//     transform: 
//       translateY(80vh) 
//       rotateX(45deg) 
//       rotateZ(90deg) 
//       scale3d(0.8, 0.8, 0.8);
//   }
//   90% { 
//     opacity: 0.8;
//   }
//   100% { 
//     transform: 
//       translateY(-100px) 
//       rotateX(0deg) 
//       rotateZ(360deg) 
//       scale3d(1.1, 1.1, 1.1);
//     opacity: 0;
//   }
// `;

// const shimmerWave3D = keyframes`
//   0% { 
//     transform: translateX(-100%) skewX(-15deg) scale3d(1, 1, 2);
//     opacity: 0;
//   }
//   50% { 
//     opacity: 1;
//     transform: translateX(0%) skewX(-8deg) scale3d(1.2, 1, 3);
//   }
//   100% { 
//     transform: translateX(200%) skewX(-15deg) scale3d(1, 1, 2);
//     opacity: 0;
//   }
// `;

// const textShine3D = keyframes`
//   0% { 
//     background-position: -200% center;
//     transform: translateZ(0);
//     text-shadow: 
//       0 0 10px rgba(255, 255, 255, 0.5),
//       0 2px 4px rgba(0, 0, 0, 0.3);
//   }
//   50% {
//     transform: translateZ(20px);
//     text-shadow: 
//       0 0 20px rgba(255, 255, 255, 0.8),
//       0 4px 8px rgba(0, 0, 0, 0.4),
//       0 8px 16px rgba(0, 0, 0, 0.2);
//   }
//   100% { 
//     background-position: 200% center;
//     transform: translateZ(0);
//     text-shadow: 
//       0 0 10px rgba(255, 255, 255, 0.5),
//       0 2px 4px rgba(0, 0, 0, 0.3);
//   }
// `;

// const rotate3D = keyframes`
//   0% {
//     transform: perspective(1000px) rotateY(0deg) rotateX(5deg);
//   }
//   100% {
//     transform: perspective(1000px) rotateY(360deg) rotateX(5deg);
//   }
// `;

// const depthPulse = keyframes`
//   0%, 100% {
//     transform: translateZ(0px);
//     box-shadow: 
//       0 10px 30px rgba(255, 69, 0, 0.3),
//       inset 0 0 20px rgba(255, 255, 255, 0.1);
//   }
//   50% {
//     transform: translateZ(20px);
//     box-shadow: 
//       0 20px 50px rgba(255, 69, 0, 0.6),
//       inset 0 0 30px rgba(255, 255, 255, 0.2);
//   }
// `;

// interface SplashScreenProps {
//   duration?: number;
//   onComplete?: () => void;
// }

// const PremiumSplashScreen3D: React.FC<SplashScreenProps> = ({ duration = 3200, onComplete }) => {
//   React.useEffect(() => {
//     const timer = setTimeout(() => {
//       onComplete?.();
//     }, duration);

//     return () => clearTimeout(timer);
//   }, [duration, onComplete]);

//   // 3D Document particles with saffron colors
//   const documents = Array.from({ length: 12 }, (_, i) => ({
//     id: i,
//     left: Math.random() * 100,
//     delay: Math.random() * 2.5,
//     duration: 4 + Math.random() * 3,
//     size: 18 + Math.random() * 30,
//     type: Math.floor(Math.random() * 3),
//     rotation: Math.random() * 360,
//     color: `rgba(${255 - Math.random() * 30}, ${69 + Math.random() * 50}, ${Math.random() * 20}, ${0.25 + Math.random() * 0.3})`
//   }));

//   const styles = {
//     container: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       width: '100%',
//       height: '100%',
//       display: 'flex',
//       flexDirection: 'column' as const,
//       justifyContent: 'center',
//       alignItems: 'center',
//       // Bhagwa (Saffron) Gradient Background
//       background: 'linear-gradient(135deg, #FF4500 0%, #FF6347 15%, #FF8C00 30%, #FFA500 45%, #FFD700 60%, #FF6347 75%, #FF4500 90%, #FF8C00 100%)',
//       backgroundSize: '400% 400%',
//       animation: `${bhagwaGradientFlow} 18s ease infinite`,
//       overflow: 'hidden',
//       zIndex: 9999,
//       fontFamily: '"Inter", "SF Pro Display", -apple-system, sans-serif',
//       perspective: '1000px',
//       transformStyle: 'preserve-3d' as const,
//     },
    
//     glassOverlay3D: {
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       width: '100%',
//       height: '100%',
//       background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 50%, rgba(255, 255, 255, 0.1) 100%)',
//       backdropFilter: 'blur(15px) saturate(180%)',
//       WebkitBackdropFilter: 'blur(15px) saturate(180%)',
//       transform: 'translateZ(10px)',
//     },
    
//     content: {
//       position: 'relative',
//       zIndex: 3,
//       textAlign: 'center' as const,
//       animation: `${fadeIn3D} 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)`,
//       padding: { xs: '1rem', sm: '1.5rem', md: '2rem' },
//       maxWidth: { xs: '90%', sm: '400px', md: '450px' },
//       width: '100%',
//       transformStyle: 'preserve-3d' as const,
//     },
    
//     logoSection: {
//       position: 'relative',
//       marginBottom: { xs: '1rem', sm: '1.5rem', md: '2rem' },
//       display: 'flex',
//       flexDirection: 'column' as const,
//       alignItems: 'center',
//       transformStyle: 'preserve-3d' as const,
//     },
    
//     logoContainer3D: {
//       position: 'relative',
//       width: { xs: '75px', sm: '85px', md: '95px' },
//       height: { xs: '75px', sm: '85px', md: '95px' },
//       marginBottom: { xs: '0.8rem', sm: '1rem', md: '1.2rem' },
//       animation: `${depthPulse} 3s ease-in-out infinite, ${rotate3D} 20s linear infinite`,
//       borderRadius: '25%',
//       padding: '10px',
//       background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.85))',
//       boxSizing: 'border-box' as const,
//       transformStyle: 'preserve-3d' as const,
//       border: '2px solid rgba(255, 255, 255, 0.3)',
//     },
    
//     logoGlow3D: {
//       position: 'absolute',
//       top: '50%',
//       left: '50%',
//       transform: 'translate(-50%, -50%) translateZ(-10px)',
//       width: { xs: '100px', sm: '110px', md: '120px' },
//       height: { xs: '100px', sm: '110px', md: '120px' },
//       background: 'radial-gradient(circle, rgba(255, 69, 0, 0.6) 0%, rgba(255, 140, 0, 0.3) 40%, transparent 70%)',
//       borderRadius: '50%',
//       animation: `${pulse3D} 3s ease-in-out infinite`,
//       filter: 'blur(12px)',
//     },
    
//     logo: {
//       width: '100%',
//       height: '100%',
//       animation: `${float3D} 4s ease-in-out infinite`,
//       filter: 'drop-shadow(0 10px 25px rgba(255, 69, 0, 0.4))',
//       borderRadius: '20%',
//       objectFit: 'contain' as const,
//       transformStyle: 'preserve-3d' as const,
//     },
    
//     title3D: {
//       fontSize: { xs: '1.9rem', sm: '2.3rem', md: '2.6rem' },
//       fontWeight: '900',
//       background: 'linear-gradient(45deg, #FFFFFF 0%, #FFFAF0 25%, #FFE4B5 50%, #FFFAF0 75%, #FFFFFF 100%)',
//       backgroundSize: '200% auto',
//       backgroundClip: 'text',
//       WebkitBackgroundClip: 'text',
//       WebkitTextFillColor: 'transparent',
//       animation: `${textShine3D} 3s ease-in-out infinite`,
//       marginBottom: { xs: '0.3rem', sm: '0.5rem', md: '0.6rem' },
//       letterSpacing: { xs: '0.8px', sm: '1.2px', md: '1.6px' },
//       textTransform: 'uppercase' as const,
//       fontFamily: '"Inter", "SF Pro Display", sans-serif',
//       lineHeight: 1.1,
//       transformStyle: 'preserve-3d' as const,
//     },
    
//     subtitle3D: {
//       fontSize: { xs: '0.8rem', sm: '0.95rem', md: '1.05rem' },
//       color: 'rgba(255, 255, 255, 0.95)',
//       fontStyle: 'italic',
//       marginBottom: { xs: '1.2rem', sm: '1.5rem', md: '2rem' },
//       animation: `${fadeIn3D} 1.2s ease-out 0.3s both`,
//       fontWeight: '400',
//       letterSpacing: '0.4px',
//       textShadow: '0 2px 10px rgba(0,0,0,0.3)',
//       transform: 'translateZ(15px)',
//     },
    
//     progressContainer3D: {
//       width: { xs: '220px', sm: '270px', md: '300px' },
//       height: '6px',
//       background: 'rgba(255, 255, 255, 0.15)',
//       borderRadius: '3px',
//       overflow: 'hidden',
//       position: 'relative' as const,
//       margin: '0 auto',
//       backdropFilter: 'blur(8px)',
//       border: '1px solid rgba(255, 255, 255, 0.2)',
//       transform: 'translateZ(10px)',
//       transformStyle: 'preserve-3d' as const,
//     },
    
//     progressWave3D: {
//       position: 'absolute' as const,
//       top: 0,
//       left: 0,
//       height: '100%',
//       width: '40%',
//       background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.7), transparent)',
//       animation: `${shimmerWave3D} 2s ease-in-out infinite`,
//       borderRadius: '3px',
//       transformStyle: 'preserve-3d' as const,
//     },
    
//     document3D: (doc: any) => ({
//       position: 'absolute' as const,
//       top: '110%',
//       left: `${doc.left}%`,
//       width: `${doc.size}px`,
//       height: `${doc.type === 1 ? doc.size * 0.7 : doc.size * 1.3}px`,
//       background: doc.color,
//       borderRadius: doc.type === 1 ? '4px 4px 8px 8px' : '2px',
//       transform: `rotate(${doc.rotation}deg) rotateX(45deg)`,
//       animation: `${documentFloat3D} ${doc.duration}s linear infinite ${doc.delay}s`,
//       boxShadow: '0 8px 25px rgba(0,0,0,0.3)',
//       transformStyle: 'preserve-3d' as const,
//       '&::before': doc.type === 2 ? {
//         content: '""',
//         position: 'absolute',
//         top: '20%',
//         left: '15%',
//         right: '15%',
//         height: '2px',
//         background: 'rgba(255, 255, 255, 0.7)',
//         borderRadius: '1px',
//         transform: 'translateZ(5px)',
//       } : {},
//       '&::after': doc.type === 0 ? {
//         content: '""',
//         position: 'absolute',
//         bottom: '25%',
//         left: '15%',
//         right: '15%',
//         height: '2px',
//         background: 'rgba(255, 255, 255, 0.5)',
//         borderRadius: '1px',
//         transform: 'translateZ(3px)',
//       } : {},
//     }),
    
//     footer3D: {
//       position: 'absolute' as const,
//       bottom: { xs: '1.2rem', sm: '1.8rem', md: '2.2rem' },
//       color: 'rgba(255, 255, 255, 0.85)',
//       fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.85rem' },
//       animation: `${fadeIn3D} 1s ease-out 0.5s both`,
//       textAlign: 'center' as const,
//       width: '100%',
//       fontWeight: '300',
//       letterSpacing: '0.4px',
//       transform: 'translateZ(20px)',
//       textShadow: '0 1px 8px rgba(0,0,0,0.3)',
//     },
    
//     featureGrid3D: {
//       display: { xs: 'none', sm: 'flex' },
//       justifyContent: 'center',
//       gap: { sm: '1.8rem', md: '2.2rem' },
//       marginTop: { sm: '1.8rem', md: '2.2rem' },
//       animation: `${fadeIn3D} 1s ease-out 0.7s both`,
//       transformStyle: 'preserve-3d' as const,
//     },
    
//     featureItem3D: {
//       textAlign: 'center' as const,
//       padding: '0.8rem 0.5rem',
//       transform: 'translateZ(15px)',
//       background: 'rgba(255, 255, 255, 0.1)',
//       borderRadius: '12px',
//       backdropFilter: 'blur(10px)',
//       border: '1px solid rgba(255, 255, 255, 0.2)',
//     },
    
//     featureIcon3D: {
//       fontSize: { sm: '1.3rem', md: '1.5rem' },
//       color: 'rgba(255, 255, 255, 0.95)',
//       marginBottom: '0.4rem',
//       filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.3))',
//       display: 'block',
//     },
    
//     featureText3D: {
//       fontSize: { sm: '0.7rem', md: '0.75rem' },
//       color: 'rgba(255, 255, 255, 0.9)',
//       fontWeight: '400',
//       letterSpacing: '0.3px',
//     },
//   };

//   return (
//     <Box sx={styles.container}>
//       {/* 3D Glass Overlay */}
//       <Box sx={styles.glassOverlay3D} />
      
//       {/* 3D Animated Document Elements */}
//       {documents.map(doc => (
//         <Box key={doc.id} sx={styles.document3D(doc)} />
//       ))}
      
//       {/* Main 3D Content */}
//       <Box sx={styles.content}>
//         <Box sx={styles.logoSection}>
//           <Box sx={styles.logoContainer3D}>
//             <Box sx={styles.logoGlow3D} />
//             <img
//               src={logo}
//               alt="DDMSS Logo"
//               style={styles.logo}
//             />
//           </Box>
          
//           <Typography variant="h1" sx={styles.title3D}>
//             DDMSS
//           </Typography>
          
//           <Typography variant="h6" sx={styles.subtitle3D}>
//             Digital Document Management System
//           </Typography>
//         </Box>
        
//         {/* 3D Progress Indicator */}
//         <Box sx={styles.progressContainer3D}>
//           <Box sx={styles.progressWave3D} />
//         </Box>
        
//         {/* 3D Feature Highlights */}
//         <Box sx={styles.featureGrid3D}>
//           <Box sx={styles.featureItem3D}>
//             <Box sx={styles.featureIcon3D}>📁</Box>
//             <Typography variant="body2" sx={styles.featureText3D}>
//               Secure
//             </Typography>
//           </Box>
//           <Box sx={styles.featureItem3D}>
//             <Box sx={styles.featureIcon3D}>⚡</Box>
//             <Typography variant="body2" sx={styles.featureText3D}>
//               Fast
//             </Typography>
//           </Box>
//           <Box sx={styles.featureItem3D}>
//             <Box sx={styles.featureIcon3D}>🔒</Box>
//             <Typography variant="body2" sx={styles.featureText3D}>
//               Reliable
//             </Typography>
//           </Box>
//         </Box>
//       </Box>
      
//       <Typography variant="body2" sx={styles.footer3D}>
//         Initializing Secure Workspace...
//       </Typography>
//     </Box>
//   );
// };

// export default PremiumSplashScreen3D;